export enum AdditionalExercisesTypes {
    GET_LIST = '@additionalExercises/GET_LIST',
    REQUEST_GET_LIST = '@additionalExercises/REQUEST_GET_LIST',
    REQUEST_SAVE_ADDITIONAL_EXERCISE = '@additionalExercises/REQUEST_SAVE_ADDITIONAL_EXERCISE',
    SAVE_ADDITIONAL_EXERCISE = '@additionalExercises/SAVE_ADDITIONAL_EXERCISE',
    DELETE_EXERCISE = '@additionalExercises/DELETE_EXERCISE',
    REQUEST_DELETE_EXERCISE = '@additionalExercises/REQUEST_DELETE_EXERCISE',
}

export type AdditionalExercise = {
    image?: string;
    id: string;
    name: Record<string, string>;
    tasks: string[] | null;
    skills: string[] | null;
    reward: string | '';
    backpack?: boolean | false;
    visibleSavedExercises: boolean | false;
};

export type AdditionalExercisesState = {
    isLoading: boolean;
    additionalExercises: AdditionalExercise[];
};

export type AdditionalExercisesAction<Payload> = {
    type: AdditionalExercisesTypes;
    payload: Payload;
};

export type AdditionalExerciseReducer = (
    state: AdditionalExercisesState,
    actions: AdditionalExercisesAction<AdditionalExercisesState>,
) => AdditionalExercisesState;
